import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import CartButton from '../../../components/CartButton';

export default function InvoiceNavbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white/98 backdrop-blur-lg shadow-md py-3' : 'bg-white/95 backdrop-blur-sm py-4 border-b border-stone-100'}`}>
      <div className="w-full px-6 lg:px-12">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 cursor-pointer group">
            <img
              src="https://static.readdy.ai/image/bff3983fcac7598cf15bb5173700e0d7/b58838733802ef1d20431284565f42b3.jpeg"
              alt="House of FMR"
              className="h-12 w-12 object-contain transition-transform duration-300 group-hover:scale-105"
            />
            <div className="hidden sm:block">
              <p className="text-stone-900 font-display text-xl tracking-wide">House of FMR</p>
              <p className="text-amber-600 text-[10px] tracking-[0.25em] uppercase font-medium">Events &amp; Styling</p>
            </div>
          </Link>

          <div className="hidden lg:flex items-center gap-8">
            <Link to="/" className="text-sm font-medium text-stone-600 hover:text-amber-600 transition-colors cursor-pointer whitespace-nowrap">Home</Link>
            <Link to="/shop" className="text-sm font-medium text-stone-600 hover:text-amber-600 transition-colors cursor-pointer whitespace-nowrap">Shop</Link>
            <Link to="/services" className="text-sm font-medium text-stone-600 hover:text-amber-600 transition-colors cursor-pointer whitespace-nowrap">Services</Link>
            <Link to="/gallery" className="text-sm font-medium text-stone-600 hover:text-amber-600 transition-colors cursor-pointer whitespace-nowrap">Gallery</Link>
            <span className="text-sm font-semibold text-amber-600 cursor-default whitespace-nowrap">Invoice Generator</span>
          </div>

          <div className="hidden lg:flex items-center gap-3">
            <CartButton />
            <Link to="/wishlist" className="w-10 h-10 rounded-full bg-stone-100 flex items-center justify-center text-stone-700 hover:bg-stone-200 transition-colors cursor-pointer" aria-label="Wishlist">
              <i className="ri-heart-line text-lg"></i>
            </Link>
            <Link to="/" className="px-6 py-2.5 bg-gradient-to-r from-amber-400 via-amber-500 to-amber-600 text-stone-900 text-sm font-semibold rounded-full hover:from-amber-300 hover:via-amber-400 hover:to-amber-500 transition-all cursor-pointer whitespace-nowrap shadow-lg shadow-amber-500/30 border border-amber-300/20">
              Back to Home
            </Link>
          </div>

          <div className="lg:hidden flex items-center gap-2">
            <CartButton />
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="w-10 h-10 rounded-full bg-stone-100 flex items-center justify-center text-stone-900 cursor-pointer">
              <i className={`ri-${mobileMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
            </button>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 bg-white rounded-2xl p-5 shadow-2xl border border-amber-100">
            <div className="space-y-1">
              <Link to="/" className="block w-full text-left px-4 py-3 text-sm font-medium text-stone-700 hover:text-amber-600 hover:bg-amber-50 rounded-lg transition-colors cursor-pointer" onClick={() => setMobileMenuOpen(false)}>Home</Link>
              <Link to="/shop" className="block w-full text-left px-4 py-3 text-sm font-medium text-stone-700 hover:text-amber-600 hover:bg-amber-50 rounded-lg transition-colors cursor-pointer" onClick={() => setMobileMenuOpen(false)}>Shop</Link>
              <Link to="/services" className="block w-full text-left px-4 py-3 text-sm font-medium text-stone-700 hover:text-amber-600 hover:bg-amber-50 rounded-lg transition-colors cursor-pointer" onClick={() => setMobileMenuOpen(false)}>Services</Link>
              <Link to="/gallery" className="block w-full text-left px-4 py-3 text-sm font-medium text-stone-700 hover:text-amber-600 hover:bg-amber-50 rounded-lg transition-colors cursor-pointer" onClick={() => setMobileMenuOpen(false)}>Gallery</Link>
              <Link to="/wishlist" className="block w-full text-left px-4 py-3 text-sm font-medium text-stone-700 hover:text-amber-600 hover:bg-amber-50 rounded-lg transition-colors cursor-pointer" onClick={() => setMobileMenuOpen(false)}>
                <i className="ri-heart-line mr-2"></i>Wishlist
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
